class ListLinks{
    constructor(el) {
        this.scope = el;
        this.title = el.querySelector("[data-title]");
        this.linksOpen = false;
        if (this.title) {
            this.bindEvents();
        }
    }

    bindEvents(){
        this.title.addEventListener("click", ()=>  this.toggleLinks());
    }

    toggleLinks(){
        this.linksOpen = !this.linksOpen;
        this.scope.classList.toggle("list-links--open", this.linksOpen);
    }
}

ControlBinders.register(`[data-list-links]`, el => new ListLinks(el));